var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#8A2B2B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2330_1760)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2811 6.90491L4.36555 4.98935L4.98922 4.36569L6.90477 6.28124L8.82032 4.36569L9.44399 4.98935L7.52844 6.90491L9.44399 8.82046L8.82032 9.44413L6.90477 7.52858L4.98922 9.44413L4.36555 8.82046L6.2811 6.90491Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2330_1760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.4,
    height: 8.4,
    fill: "white",
    transform: "translate(2.8 2.80005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotSelected);
export default __webpack_public_path__ + "static/media/icon-not-selected.a49d4ed85993d519025c630a979d75c1.svg";
export { ForwardRef as ReactComponent };